import HobbiesBackground from '../components/HobbiesBackground';
import SectionHeader from '../components/SectionHeader';
import { hobbies } from '../data/portfolio';
import styles from './Hobbies.module.css';

function Hobbies() {
  return (
    <div className={styles.hobbies}>
      <HobbiesBackground />
      <SectionHeader 
        title="Hobbies & Activities" 
        subtitle="What I enjoy beyond coding"
      />
      
      <div className={styles.hobbyGrid}>
        {hobbies.map(hobby => (
          <div key={hobby.id} className={styles.hobbyCard}>
            <h3 className={styles.hobbyTitle}>{hobby.title}</h3>
            <p className={styles.hobbyDescription}>{hobby.description}</p>
          </div>
        ))}
      </div>

      <div className={styles.philosophy}>
        <h3>Balance & Growth</h3>
        <p>
          I believe in maintaining a healthy balance between professional development 
          and personal interests. These activities help me stay creative, collaborative, 
          and continuously learning both inside and outside the tech world.
        </p>
      </div>
    </div>
  );
}

export default Hobbies;
